import ResourceService from "./resource.service";

class BranchService extends ResourceService {
  static get resource() {
    return "branch";
  }
}

export default BranchService;
